<template>
  <div
      v-if="false && showCTA && ctaLink !== '' && ctaLink !== null && shouldShowOnThisPage"
      class="fixed bottom-4 left-1/2 transform cursor-pointer -translate-x-1/2 w-auto px-6 py-3 bg-[var(--cta-bg)] text-white font-bold text-lg rounded-full shadow-lg transition-all duration-300 hover:scale-105"
      @click="handleClick"
      :style="ctaStyles"
  >
    {{ ctaText }}
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useRoute } from "vue-router";

const props = defineProps({
  ctaText: { type: String, required: true },
  ctaLink: { type: String, default: "#" },
  colors: { type: Object, required: true }
});

const route = useRoute();
const shouldShowOnThisPage = computed(() => {
  const path = route.path;
  return (
    path === '/' ||
    path === '/about' ||
    path.startsWith('/product') ||
    path.startsWith('/post')
  );
});

const showCTA = ref(false);

// Detect scroll and show CTA when the user scrolls down
const handleScroll = () => {
  showCTA.value = window.scrollY > 150; // Adjust based on when you want it to appear
  // hide near the bottom
  if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 700) {
    showCTA.value = false;
  }
};

// Navigate to CTA link when clicked
const handleClick = () => {
  const targetElement = document.getElementById("contact");
  if (targetElement) {
    const sectionTop = targetElement.offsetTop; // - navHeight.value;
    window.scrollTo({
      top: sectionTop,
      behavior: "smooth"
    });
  }
  else {
    window.location.href = props.ctaLink;
  }

};

// Compute dynamic colors
const ctaStyles = computed(() => ({
  "--cta-bg": props.colors.accent
}));

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
/* Smooth transition */
.fixed {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}
</style>
